import { useSyncExternalStore } from 'react';

/**
 * Hook to monitor network connectivity status
 * Uses navigator.onLine and online/offline events
 */
export const useNetworkStatus = (): boolean => {
  return useSyncExternalStore(
    (callback) => {
      if (typeof window === 'undefined') {
        return () => {};
      }

      window.addEventListener('online', callback);
      window.addEventListener('offline', callback);
      return () => {
        window.removeEventListener('online', callback);
        window.removeEventListener('offline', callback);
      };
    },
    () => {
      if (typeof navigator === 'undefined') {
        return true;
      }
      return navigator.onLine;
    },
    () => true // server-side default
  );
};
